module.exports = __webpack_public_path__ + "static/media/train14.0724e729.png";